import opportunity from ".";
import * as types from "./types";

const mutations = {
    [types.LOADING_COMPLAINTS](state, value) {
        state.loading = value;
    },
    [types.GET_COMPLAINTS_LIST](state, complaints) {
        state.complaints = complaints;
    },
    [types.REMOVE_COMPLAINTS](state, id) {        
        state.complaints = state.complaints.filter((x) => x.id !== id);        
    },
    [types.ADD_COMPLAINTS](state, complaint) {        
        state.complaints.unshift(complaint);
        state.newComplaints = complaint;
    },
    [types.UPDATE_COMPLAINTS](state, complaint) {        
        const complaintIndex = state.complaints.findIndex((x) => x.id === complaint.id);
        state.complaints[complaintIndex] = complaint;        
    },
    [types.GET_COMPLAINT_ID](state, complaintId) {
        state.complaintId = complaintId;
    },
    [types.GET_FEEDBACK_ID](state, feedback) {
        state.feedback = feedback;
    },

    [types.REMOVE_FEEDBACK](state, id) {        
        state.feedback = state.feedback.filter((x) => x.id !== id);        
    },

    [types.UPDATE_COMPLAINT_STATUS](state, payload) {
        const complaintIndex = state.complaints.findIndex((x) => x.id === payload.id);
        if (complaintIndex !== -1) {
            state.complaints[complaintIndex].status = payload.status;
        }
    },
 };

 export default mutations;